<template>
  <b-modal
      ref="confirmModal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      content-class="modal-confirm-content"
  >
    <div class="modal-confirm-body">

      <div class="icon-wrap">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path
              d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
          />
        </svg>
      </div>

      <h2 class="modal-confirm-title">{{ title }}</h2>
      <p class="modal-confirm-description">{{ description }}</p>

      <div class="modal-confirm-actions">
        <button class="btn-cancel" @click="onCancel">Não</button>
        <button class="btn-confirm" @click="onConfirm">Sim, confirmar</button>
      </div>

    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmModal',

  props: {
    title: { type: String, default: 'Confirmar ação' },
    description: { type: String, default: 'Tem certeza que deseja continuar?' }
  },

  methods: {
    show() {
      this.$refs.confirmModal.show()
    },

    hide() {
      this.$refs.confirmModal.hide()
    },

    onConfirm() {
      this.$emit('confirm')
      this.hide()
    },

    onCancel() {
      this.$emit('cancel')
      this.hide()
    }
  }
}
</script>

<style>
/* Sem scoped — precisa sobrescrever classes do BootstrapVue */
.modal-confirm-content {
  border: none;
  border-radius: 16px;
  overflow: hidden;
}

.modal-confirm-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.75rem 1.5rem 1.5rem;
}

.icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #faeeda;
  color: #ba7517;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.modal-confirm-title {
  font-size: 17px;
  font-weight: 500;
  text-align: center;
  margin: 0 0 0.5rem;
  color: #111;
}

.modal-confirm-description {
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 1.6;
  margin: 0 0 1.75rem;
}

.modal-confirm-actions {
  display: flex;
  gap: 10px;
  width: 100%;
}

.btn-cancel,
.btn-confirm {
  flex: 1;
  padding: 10px 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  border: none;
}

.btn-cancel {
  background: #f4f4f4;
  color: #333;
  border: 0.5px solid rgba(0, 0, 0, 0.15);
}
.btn-cancel:hover { background: #e8e8e8; }

.btn-confirm {
  background: #556ee6;
  color: #fff;
}
.btn-confirm:hover { background: #3452e1; }

.btn-cancel:active,
.btn-confirm:active { transform: scale(0.97); }
</style>